import React from 'react';
import {Box, styled} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';
import {scrollbarMixins} from '@contentlab/styles/mixins';

interface FeatureDetailsProps {
  testID?: string;
  featureDetailsComponent?: React.ReactNode;
}

const Container = styled(Box)(() => ({
  boxSizing: 'border-box',
  backgroundColor: designSystemToken('semantic.bg.secondary'),
  borderRadius: '32px',
  width: '100%',
  flexGrow: 1,
  minHeight: 0,
  minWidth: 0,
  border: `1px solid ${designSystemToken('semantic.bg.neutral-secondary')}`,
  overflowY: 'auto',
  ...scrollbarMixins.overrideScrollbarHidden(),
}));

function FeatureDetails({
  testID = 'feature-details',
  featureDetailsComponent,
}: FeatureDetailsProps) {
  return <Container data-testid={testID}>{featureDetailsComponent}</Container>;
}

export default FeatureDetails;
